import { GameModel } from "@nolimitcity/slot-game/bin/model/GameModel";

import { EventsManager, GameEvents } from "../events/EventsManager";
import { AbstractGameMode } from "../flow/AbstractGameMode";
import { log } from "../utils/AbstractConsole";
import { AbstractView } from "./AbstractView";

let gameModel: GameModel<any, any>;
export const setModelForModulesController = (model: GameModel<any, any>) => (gameModel = model);

export class AbstractModuleController {
    constructor() {
        this.init();
    }

    protected _view: AbstractView;

    public get view(): AbstractView {
        if (this._view === undefined || this._view === null) {
            this._view = new AbstractView(AbstractGameMode.NORMAL);
        }

        return this._view;
    }

    public get name(): string {
        return `AbstractModuleController`;
    }

    protected init(): void {
        this.handleView();
        this.handleEvents();
    }

    protected handleView(): void {
        if (!gameModel) {
            log(`gameModel not set!`);
        }
        this.view.gameMode = gameModel.data.mode;
    }

    protected handleEvents(): void {
        EventsManager.on(GameEvents.UPDATE_GAME_MODE, (gameMode: AbstractGameMode) => {
            this.onGameModeUpdate(gameMode);
        });
    }

    protected onGameModeUpdate(gameMode: AbstractGameMode): void {
        this.view.gameMode = gameMode;
    }
}
